import { render } from "./ReserveShow.vue?vue&type=template&id=97329df0&scoped=true"
import script from "./ReserveShow.vue?vue&type=script&lang=js"
export * from "./ReserveShow.vue?vue&type=script&lang=js"

import "./ReserveShow.vue?vue&type=style&index=0&id=97329df0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97329df0"]])

export default __exports__